export const GET_CLIENTS_SOCIETIES = 'sagas/clientSociety/GET_CLIENTS_SOCIETIES';
export const CREATE_CLIENT_SOCIETY = 'sagas/clientSociety/CREATE_CLIENT_SOCIETY';
